import { ClientConfig, ClientConfigOptions } from '../../clientConfig';
import { Request } from '../../common/request';
import { ApiResult } from '../../common/types';
import {
   AddContractSignParams,
   SignTemplateListParams,
   LaunchPreviewV2Params,
   QuerySignInfoByContractNumParams,
   SignTemplateDetailsParams,
   SignContractSignParams
} from './model';

export class ContractSignClient {
   private config: ClientConfig;
   private service: Request;

   constructor(options: ClientConfigOptions) {
      this.config = new ClientConfig(options);
      this.service = new Request(this.config.getConfig());
   }

/**
    * 指定签署方和签署内容发起签署
    * @param {AddContractSignParams} params - 指定签署方和签署内容发起签署参数
    * @returns {Promise<ApiResult>} 指定签署方和签署内容发起签署结果
    */
   addContractSign(params: AddContractSignParams): Promise<ApiResult> {
      const processedParams = {
         ...params,
         signatoryInfos: params.signatoryInfos ? JSON.stringify(params.signatoryInfos) : undefined
      };
      return this.service.post(`/openAPI/contractSign/pro/addContractSign`, processedParams);
   }

   // 
 
   // sign	String	是	签名
   /**
    * 静默签署盖章接口
    * @param params 
    * @param {string} params.customerOriginationNumber - 客户发起时定义的编号
    * @param {string} params.userPhone - 发起用户手机号
    * @returns 
    */
   signContractSign(params: SignContractSignParams): Promise<ApiResult> {
      return this.service.post(`/openAPI/contractSign/max/signContractSign`, params);
   }

   /**
    * 查询合同详情
    * @param {QuerySignInfoByContractNumParams} params - 查询合同详情参数
    * @param {string} params.contractNum - 合同编号
    * @param {string} params.sign - 签名
    * @returns {Promise<ApiResult>} 查询合同详情结果
    */
   querySignInfoByContractNum(params: QuerySignInfoByContractNumParams): Promise<ApiResult> {
      return this.service.post(`/openAPI/contractSign/v1/querySignInfoByContractNum`, params);
   }
   
   /**
    * 查询合同模板列表
    * @param {SignTemplateListParams} params - 查询合同模板参数
    * @param {number} params.isOpen - 是否启用 0-否 1-是
    * @param {string} params.sign - 签名
    * @returns {Promise<ApiResult>} 查询合同模板结果
    */
   signTemplateList(params: SignTemplateListParams): Promise<ApiResult> {
      return this.service.post('/openAPI/contractSign/signTemplateList', params);
   } 


   /**
    * 查询模板详情
    * @param {SignTemplateDetailsParams} params - 查询模板详情参数
    * @param {string} params.contractModelNum - 模板编号
    * @param {string} params.sign - 签名
    * @returns {Promise<ApiResult>} 查询模板详情结果
    */
   signTemplateDetails(params: SignTemplateDetailsParams): Promise<ApiResult> {
      return this.service.post('/openAPI/contractSign/signTemplateDetails', params);
   }


   /**
    * 合同发起预览填V2
    * @param {LaunchPreviewV2Params} params - 合同发起预览填V2参数
    * @returns {Promise<ApiResult>} 合同发起预览填V2结果
    */
   launchPreviewV2(params: LaunchPreviewV2Params): Promise<ApiResult> {
      return this.service.post('/openAPI/contractSign/v2/launchPreview', params);
   }
}
